import Axios from 'axios' 
import {
  SYSUSERGRANTROLE_UNSET_ALL_STATE,
  SYSUSERGRANTROLE_SET_MSG,
  SYSUSERGRANTROLE_UNSET_MSG,
  SYSUSERGRANTROLE_SET_SCHEMA,
  SYSUSERGRANTROLE_UNSET_SCHEMA,
  SYSUSERGRANTROLE_SET_ACTION_PROCESS,
  SYSUSERGRANTROLE_UNSET_ACTION_PROCESS,
  SYSUSERGRANTROLE_SET_LIST_DATA, 
  SYSUSERGRANTROLE_UNSET_LIST_DATA,
  SYSUSERGRANTROLE_SET_ACTION_STATUS,
  SYSUSERGRANTROLE_UNSET_ACTION_STATUS

} from '../mutation-types'

const state = {     
  dataList: [],   
  message: '',
  actionStatus:false, 
  actionProcess:false, 
  Schema:{ 
    active: 1,
    grant_role_id: 0,
    user_id: 0,
    role_id: '',
    login_id: '',
    id:0
  }
}

const getters = {
  get_SYSUSERGRANTROLE_DataList (state) {
    return state.dataList ;
  }, 
  get_SYSUSERGRANTROLE_ActionMessage(state){
    return state.message ;
  },
  get_SYSUSERGRANTROLE_Schema(state){
    return state.Schema
  },
  get_SYSUSERGRANTROLE_ActionProcess(state){
    return state.actionProcess ;
  },
  get_SYSUSERGRANTROLE_ActionStatus(state){
    return state.actionStatus ;
  },

}

// mutations

const	mutations = {	
  [SYSUSERGRANTROLE_UNSET_ALL_STATE] (state){
    state.actionProcess = false,
    state.dataList = [],      
    state.Schema = {
      active: 1,
      user_id: 0,
      role_id: 0,
      login_id: '',
      id:0
    }  
  },
  [SYSUSERGRANTROLE_SET_ACTION_STATUS](state){
    state.actionStatus = true
  },
  [SYSUSERGRANTROLE_UNSET_ACTION_STATUS](state){
    state.actionStatus = false
  },
  [SYSUSERGRANTROLE_SET_MSG](state,msg){
    state.message = msg
  },
  [SYSUSERGRANTROLE_UNSET_MSG](state){
    state.message = ""
  },
  [SYSUSERGRANTROLE_UNSET_ACTION_PROCESS]( state ){ 
    state.actionProcess = false
  },
  [SYSUSERGRANTROLE_SET_ACTION_PROCESS]( state ){
    state.actionProcess = true 
  },
  [SYSUSERGRANTROLE_SET_LIST_DATA](state,itemList){
    state.dataList = itemList 
  },
  [SYSUSERGRANTROLE_UNSET_LIST_DATA](state){
    state.dataList = [] 
  },
  [SYSUSERGRANTROLE_SET_SCHEMA](state,schemaData){
    state.Schema = [] 
    state.Schema = schemaData 
  },
  [SYSUSERGRANTROLE_UNSET_SCHEMA](state){
    state.Schema = [] 
    state.Schema.active =1
  },
}

// Actions

const actions = {
	
}
export default {
 state,
 getters,
 actions,
 mutations
}



// WEBPACK FOOTER //
// ./src/vuex/module/dia_sysUsergrantRole_module.js